document.addEventListener("DOMContentLoaded", function () {
  // Find the container that holds the article content + TOC container
  const psContent = document.querySelector('.ps-content');
  if (!psContent) return; // Exit if not found

  // Find the TOC container INSIDE ps-content
  const tocContainer = psContent.querySelector('#toc');
  if (!tocContainer) return; // Exit if toc container not found inside ps-content

  // Get all H2 headings inside ps-content (your article headings)
  const headings = psContent.querySelectorAll('h2');
  if (headings.length === 0) {
    tocContainer.style.display = 'none'; // Hide TOC if no headings found
    return;
  }

  // Build TOC list HTML
  let tocHTML = '<ul>';
  headings.forEach((heading, idx) => {
    // Give each heading an ID if it doesn't have one
    if (!heading.id) {
      heading.id = `heading-${idx}`;
    }
    const text = heading.textContent.trim();
    if (text) {
      tocHTML += `<li><a href="#${heading.id}">${text}</a></li>`;
    }
  });
  tocHTML += '</ul>';

  // Inject the TOC HTML into the container inside ps-content
  tocContainer.innerHTML = tocHTML;

  // Add scroll offset behavior (ONLY this part added)
  const links = tocContainer.querySelectorAll('a');
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        const yOffset = -120; // Offset from top
        const y = targetEl.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });
});
